﻿import {UpgradeType} from "../../enums";
import {Core} from "../../Base/Core";
import {PlayerPrefs} from "../../Utils/Unity/PlayerPrefs";
import {UICommonPopup} from "../Tools/Base/UICommonPopup";
import {UIText} from "../Tools/Base/UIText";
import {UISprite} from "../Tools/Base/UISprite";
import {RewardedAdsBtn} from "../RewardedAdsBtn";
import {UINineSlice} from "../Tools/Base/UINineSlice";

const PREFS_NEXT_EVOLVE_BONUS = "2ctynyv5vb4n572c4334";
const BONUS_TIMEOUT = 300 * 1000; // 5 minutes

export class UIAdsEvolve extends UICommonPopup {

    get nextEvolveBonusAvailable() {
        return PlayerPrefs.GetInt(PREFS_NEXT_EVOLVE_BONUS, Date.now() + BONUS_TIMEOUT);
    }

    set nextEvolveBonusAvailable(value) {
        PlayerPrefs.SetInt(PREFS_NEXT_EVOLVE_BONUS, value);
    }

    _resetTimeout() {
        this.nextEvolveBonusAvailable = Date.now() + BONUS_TIMEOUT;
    }

    Awake() {
        super.Awake({
            title: Core.Localizator.Get("evolve_bonus_title"),
            closeButton: true
        });

        this.onWatched = this.onWatched.bind(this);

        this.description = this.content.addChild(new UIText(Core.Localizator.Get("evolve_bonus_desc"), {
            fontSize: 16 * Core.app.renderer.resolution
        }));
        this.creaturesBack = this.content.addChild(new UINineSlice("bg-rounding-28px"));
        this.creaturesBack.tint = 0x000000;
        this.creaturesBack.alpha = 0.3;
        this.arrow = this.content.addChild(new UISprite("arrow-green"));
        this.creature1Image = this.content.addChild(new UISprite());
        this.creature2Image = this.content.addChild(new UISprite());
        this.evolveBtn = this.content.addChild(new RewardedAdsBtn("btn-green", {label: Core.Localizator.Get("evolve")}));
        this.requestedCreatureView = null;
        this.requestedCreatureId = 0;
        this.nextCreatureId = 0;

        this._resetTimeout();

        this.evolveBtn.on("pointertap", () => {
            Core.Ads.TriggerRewarded(this.onWatched);
        });
    }

    onWatched() {
        if (this.requestedCreatureView && this.requestedCreatureView.creatureController && this.requestedCreatureView.creatureController.creatureId == this.requestedCreatureId) {
            this._resetTimeout();
            this.requestedCreatureView.Evolve(this.nextCreatureId);
            this.Hide();
        }
    }

    _checkTapChallenge() {
        let currentProgress = Core.Player.PlanetsSave.GetUpgradeProgress(UpgradeType.TapChallengeMergeBonus);
        if (!currentProgress || currentProgress.upgradeIndex === 0) return true;

        // on GetMergeProgress == 0 or totalValue - 1 we might start TapChallenge
        let tapProgress = Core.Player.PlanetsSave.CurrentPlanet.GetMergeProgress();
        if (tapProgress === 0) return false;

        let upgradeData = Core.GameData.Upgrades.UpgradeByType(UpgradeType.TapChallengeMergeBonus);
        let totalValue = upgradeData.TotalValue(currentProgress.upgradeIndex);

        if (tapProgress === totalValue - 1) return false;
        return true;
    }

    Show(creatureId1, creatureView) {
        if (!this._checkTapChallenge()) return;

        // check time
        if (this.nextEvolveBonusAvailable > Date.now()) return; // Not now, it's too early

        let creatureData1 = Core.GameData.Creatures.Get(creatureId1);
        let planet = Core.Player.PlanetsSave.CurrentPlanet;

        // check input data
        if (!planet || !creatureData1) return; // Something wrong with data

        let collection = Core.Player.PlanetsSave.CurrentPlanet.collection;

        let availableCreatures = collection.slice(Core.GameData.Config.adsEvolveBonusCreatureId - 1, -2).slice(-4);
        if (availableCreatures.length < 1) return; // Not enough opened creatures
        if (!availableCreatures.includes(creatureId1)) return; // Creature is not in bonus list

        this.nextCreatureId = collection[collection.indexOf(creatureId1) + 1];
        let nextCreatureData = Core.GameData.Creatures.Get(this.nextCreatureId);

        // check creature id
        if (!nextCreatureData) return;

        this.requestedCreatureId = creatureId1;
        this.requestedCreatureView = creatureView;

        this.creature1Image.setImage(`creatures/${creatureData1.id}`);
        this.creature2Image.setImage(`creatures/${nextCreatureData.id}`);

        this._resetTimeout();
        super.Show();
    }

    fitLayout(viewport = Core.app.viewport) {
        this.setPopupSize(viewport.width * 0.8, viewport.width * 0.9);
        super.fitLayout(viewport);
        let contentRect = this.getContentSize();
        contentRect.y += contentRect.width * 0.15;
        contentRect.height -= contentRect.y;

        let descRect = contentRect.clone().pad(-contentRect.width * 0.1, 0);
        descRect.height = contentRect.height * 0.2;
        this.description.fitLayout(descRect);

        let creaturesRect = contentRect.clone().pad(-contentRect.width * 0.05, -contentRect.height * 0.2);
        creaturesRect.y = descRect.bottom;
        this.creaturesBack.fitLayout(creaturesRect);

        let padding = creaturesRect.width * 0.05;
        let innerRect = creaturesRect.clone().pad(-padding);

        let creatureRect = innerRect.clone();
        creatureRect.width = innerRect.width * 0.35;
        this.creature1Image.fitRect(creatureRect);

        creatureRect.x = creatureRect.right + padding;
        creatureRect.width = innerRect.width * 0.2;
        this.arrow.fitRect(creatureRect);

        creatureRect.x = creatureRect.right + padding;
        creatureRect.width = innerRect.width * 0.35;
        this.creature2Image.fitRect(creatureRect);

        let btnRect = contentRect.clone().pad(-contentRect.width * 0.3, -contentRect.height * 0.45);
        btnRect.y = contentRect.bottom - btnRect.height - contentRect.height * 0.05;
        this.evolveBtn.fitLayout(btnRect);
    }
}
